import { render, staticRenderFns } from "./AddProviderParametersModal.vue?vue&type=template&id=704246cd&"
import script from "./AddProviderParametersModal.vue?vue&type=script&lang=js&"
export * from "./AddProviderParametersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports